import React from 'react';
import { ArrowRight } from 'lucide-react';

const serif = { fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 };

// Answers here must match the FAQPage schema below exactly (Google requirement).
const FAQS = [
  {
    q: 'What is project memory software?',
    a: 'Project memory software keeps a running record of every decision, approval, and change on a project. Archen™ builds that record automatically from the email and files your studio already produces, so the history is there whenever you need it.',
  },
  {
    q: 'How is this different from typical project management software?',
    a: 'Project management tools ask you to enter and maintain data: tasks, statuses, updates. Archen™ works the other way around. It reads the work you already do and captures the record for you, so there is nothing new to keep current.',
  },
  {
    q: 'Does this require changing how a studio already emails and files things?',
    a: 'No. You keep working exactly as you do today. Archen™ connects to the tools you already use and builds the record in the background. There is no new inbox, no new filing system, and no data entry.',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};

const FAQSection = () => (
  <section className="bg-[#FDF8F3] py-24 md:py-32" data-testid="home-faq-section">
    <div className="max-w-[1240px] mx-auto px-6 md:px-10">
      <p className="text-[#7A5A2E] text-[11px] tracking-[0.24em] uppercase mb-5">Questions</p>
      <h2
        className="text-[#1F1812] max-w-[620px]"
        style={{ ...serif, fontSize: 'clamp(1.9rem, 3.2vw, 2.9rem)', lineHeight: 1.08, letterSpacing: '-0.02em' }}
      >
        Common questions about project memory.
      </h2>

      <dl className="mt-14 grid max-w-[820px]">
        {FAQS.map(({ q, a }, i) => (
          <details key={i} className="group border-t border-[#EAE1D3] py-6 last:border-b" data-testid={`faq-item-${i}`}>
            <summary className="flex items-center justify-between gap-6 cursor-pointer list-none [&::-webkit-details-marker]:hidden text-[#1F1812] text-[20px] md:text-[22px]" style={serif}>
              {q}
              <ArrowRight size={18} className="shrink-0 text-[#7A5A2E] rotate-90 transition-transform duration-200 group-open:-rotate-90" />
            </summary>
            <p className="mt-4 text-[#3D3A36] text-[16px] md:text-[17px] leading-[1.7] max-w-[62ch]">{a}</p>
          </details>
        ))}
      </dl>
    </div>

    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
  </section>
);

export default FAQSection;
